'use client'
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { useState, useEffect, useRef } from 'react'

export default function Index() {
    const [cookieConsent, setCookieConsent] = useState(false)
    const isMountedRef = useRef(true)

    useEffect(() => {
        isMountedRef.current = true
        if (typeof window !== 'undefined') {
            try {
                const stickyValue = localStorage.getItem('cookiesSticky')
                if (!stickyValue) {
                    // Используем setTimeout для асинхронного обновления состояния
                    setTimeout(() => {
                        if (isMountedRef.current) {
                            setCookieConsent(true)
                        }
                    }, 0)
                } else {
                    //allowAllCookies()
                }
            } catch (error) {
                console.error('Error reading cookie consent:', error)
            }
        }
        return () => {
            isMountedRef.current = false
        }
    }, [])

    const handleAcceptAll = () => {
        try {
            if (typeof window !== 'undefined') {
                localStorage.setItem('cookiesSticky', 'true')
            }
            //allowAllCookies()
            if (isMountedRef.current) {
                setCookieConsent(false)
            }
        } catch (error) {
            console.error('Error saving cookie consent:', error)
        }
    }

    const handleDecline = () => {
        if (isMountedRef.current) {
            setCookieConsent(false)
        }
    }

    const text =
        'Cookies settings: We use cookies to improve your experience on our site. By continuing to browse, you agree to our use of cookies.'
    const buttonAllow = 'Allow Cookies'
    const buttonDecline = 'Decline Cookies'

    if (!cookieConsent) {
        return null
    }

    return (
        <AppBar
            position='fixed'
            color='inherit'
            sx={{ top: 'auto', bottom: 0 }}
            component='aside'
            aria-label='cookie banner'
        >
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        pb: 2,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                            pt: 2,
                        }}
                    >
                        <InfoIcon color='info' />
                        <Typography
                            sx={{
                                display: 'inline',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                gap: 1,
                            }}
                        >
                            {text}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Button
                            variant='outlined'
                            color='primary'
                            onClick={handleAcceptAll}
                        >
                            {buttonAllow}
                        </Button>
                        <Button
                            variant='text'
                            color='info'
                            onClick={handleDecline}
                        >
                            {buttonDecline}
                        </Button>
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    )
}


